import { IOptions, IObj } from '../../constants/types/common.types'
import { STATIC_URL } from '../data'
import { LectorSearchURL } from './lector-search-data'
import { themeTexts, typeTexts, FilterTypeName, Key, pageKeys } from './search-data'
import { formatCheckbox, formatSelect, formatDateParam } from '../../utils/search/formatParams'
import { IInitParams } from '../types/search.types'
import { IBasicCard } from 'constants/types/card.types'

const ContentType = {
  VIDEO: 'video',
  ARTICLE: 'article',
  WEBINAR: 'webinar',
}

const lectureSingleCheckboxes = [
  {
    label: 'Видео',
    value: ContentType.VIDEO,
  },
  {
    label: 'Статьи',
    value: ContentType.ARTICLE,
  },
  {
    label: 'Вебинары',
    value: ContentType.WEBINAR,
  },
]

const types = lectureSingleCheckboxes.map(({ value }) => value)

/* Для единообразия с другими фильтрами */
const Option = {
  lector: 'Лектор',
}

const InitParams: IObj<IInitParams> = {
  [Option.lector]: {
    [Key.TEXT]: '',
    [Key.TYPES]: types,
    [Key.THEMES]: [],
    [Key.DATES]: [],
    [Key.PAGE]: '1',
  },
}

const InitValues = {
  params: {
    [Option.lector]: InitParams[Option.lector],
  },
  pages: {
    [Option.lector]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
  },
  cards: {
    [Option.lector]: [] as IBasicCard[],
  },
  allCount: {
    [Option.lector]: 0,
  },
}

const generateConfig = (themes: IOptions[]) => ({
  [Option.lector]: {
    input: {
      placeholder: 'Поиск по названию...',
      key: Key.TEXT,
      sideIconPath: `${STATIC_URL}/filters/search-icon.svg`,
    },
    main: [
      {
        inputType: FilterTypeName.CALENDAR,
        title: 'Период публикации',
        // maxDate: new Date(),
        key: Key.DATES,
        formatter: formatDateParam,
      },
      {
        inputType: FilterTypeName.SELECT,
        themes: themes,
        mobileSwitchBtnText: themeTexts,
        title: 'Тема',
        placeholder: 'Выберите тему...',
        key: Key.THEMES,
        formatter: formatSelect,
      },
      {
        inputType: FilterTypeName.CHECKBOX,
        checkboxes: lectureSingleCheckboxes,
        mobileSwitchBtnText: typeTexts,
        noPCTitle: true,
        key: Key.TYPES,
        formatter: formatCheckbox(lectureSingleCheckboxes),
      },
    ],
  },
})

const URlbyType = {
  [ContentType.ARTICLE]: LectorSearchURL.LECTURE_ARTICLES,
  [ContentType.VIDEO]: LectorSearchURL.LECTURE_VIDEO,
  [ContentType.WEBINAR]: LectorSearchURL.LECTURE_WEBINARS,
}

export { InitValues, InitParams, generateConfig, Key, types, ContentType, URlbyType, Option }
